import {getDate} from '../../../../../../@casino/lib/getDate';

const columns = [
    { id: 'id', label: 'ID'},
    { id: 'date', label: 'Дата'},
    { id: 'operation', label: `Действие`},
    { id: 'summ', label: 'Сумма'},
    { id: 'game', label: 'Игра'},
    { id: 'balance_before', label: 'Баланс до'},
    { id: 'balance_after', label: 'Баланс после'},

    { id: 'transaction', label: 'Транзакция'}
    
];

const getRows = (data) => {
    return data.map((item) => {
        return {
            id: item.id,
            date: getDate(+item.date_event),
            operation: item.action === 'bet' ? 'SPIN' : item.action === 'win' ? 'Выигрыш' : 'Неизвестно',
            game: item.game_uuid,
            summ: new Intl.NumberFormat('ru-RU').format(item.amount) + '₽',
            balance_before: new Intl.NumberFormat('ru-RU').format(item.balance_before) + '₽',
            balance_after: new Intl.NumberFormat('ru-RU').format(item.balance_after) + '₽',
            transaction: item.client_transaction_id
        }
    })
} 

export {
    columns,
    getRows
}